import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import Accounts from "./Accounts";
import AccountView from "./Accounts/View";
import { useAppInfo } from "../../context/app";
import IntegrationDashboard from "./IntegrationDashboard";
import GetStarted from "./GetStarted";
import Support from "./Support";
import { SocketProvider } from "../../context/socket";
const useRoutes = () => {
  const [app] = useAppInfo();
  const routes = [
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      component: app?.featuresInclude?.includes("Conversation Providers") ? (
        <Dashboard />
      ) : (
        <IntegrationDashboard />
      ),
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Accounts",
      key: "accounts",
      route: "/accounts",
      component: <Accounts />,
    },
    {
      key: "accounts",
      route: "/accounts/view/:locationId",
      component: <AccountView />,
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Get Started",
      key: "get_started",
      route: "/get_started",
      component: <GetStarted />,
    },
    {
      icon: <Icon icon="mdi:headset" className="menu-icon" />,
      title: "Support",
      key: "support",
      route: "/support",
      component: (
        <SocketProvider>
          <Support />
        </SocketProvider>
      ),
    },
  ];
  return routes;
};

export default useRoutes;
